import type { FaireProductEntity } from "../../entity_types/product";

export const p_k6t652h87t: FaireProductEntity = {
  token: "p_k6t652h87t",
  type: "product",
  name: "Golden Coast– Air Freshener",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/8626a5abcbe160269355d5bb58691b60a7cd4e6e73fdda806962342c2cf41854.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7142bb866994c6dc6220f6103ce66b954f74d4cd2a372bc9570618e227b1d489.jpeg",
    "https://cdn.faire.com/fastly/a50866a1f7383f85c7f7f691ebc98cf3cdc8e0dd0f619ac5e8442dbe14170744.jpeg",
    "https://cdn.faire.com/fastly/b75f05b6109f487bb4402cfd2ea5fa3d7f062f695803ffcd734d15fbc70ed3dd.jpeg",
    "https://cdn.faire.com/fastly/b9c45cfc05848cab714e475a65a0831162a41d07571fb3b0cb71dd1302465c26.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "Big Sur magic, wild sage baking in the sun, the rumble of waves and rocks. Eucalyptus, sea salt, redwood, and palo santo.\n\nAir Fresheners are a flame-free collection designed to scent small spaces, like closets, bathrooms, gym lockers, trash cans, hotel rooms, and anywhere else that needs a little fragrance boost. \n\nThey are pre-packed in pairs, featuring an iconic P.F. Candle-shape and signature kraft paper look. Available in 8 best-selling Classic Line scents. ",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:51.695Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
